import { useTranslation } from 'react-i18next'

import { FormModalContainer, useCloseConfirm } from '../../../../../Form'
import { FormikForm } from '../../../../../Formik'
import { getListingUnitLabel } from '../../../../../RentalPortalListing'
import { useApplicantProfileContext } from '../../../RentalPortalApplicantProfile.hooks'
import { getApplicantMatchedListingFacts } from '../../../RentalPortalApplicantProfileWidgetMatchedListing'

import { QA_NAME_MATCH_REQUEST_MODAL } from './ApplicantFitCheckRequestModal.constants'
import {
  assertMatchRequestDraftIsClean,
  getMatchRequestInitialValues,
} from './ApplicantFitCheckRequestModal.utils'
import { ApplicantFitCheckRequestModalFields } from './ApplicantFitCheckRequestModalFields'

function ApplicantFitCheckRequestModal({ match, onClose, onSend }) {
  const { t } = useTranslation()

  const { applicantData } = useApplicantProfileContext()

  const { handleClose, isCloseConfirm, setCloseConfirm } = useCloseConfirm({
    onClose,
  })

  const initialValues = getMatchRequestInitialValues({
    listingFacts: getApplicantMatchedListingFacts({
      matchedListing: applicantData?.matched_listing,
      t,
    }),
    listingLabel: getListingUnitLabel({ listing: applicantData, t }),
    match,
    t,
  })

  assertMatchRequestDraftIsClean(initialValues)

  async function handleSubmit(values) {
    assertMatchRequestDraftIsClean(values)

    return onSend({
      informationTextVersion: match.information_text?.version,
      values,
    })
  }

  return (
    <FormikForm
      Container={FormModalContainer}
      containerProps={{
        isCloseConfirm,
        qaName: QA_NAME_MATCH_REQUEST_MODAL,
        setCloseConfirm,
        title: t('RentalPortal.MatchRequestModalTitleKey'),
        onClose,
      }}
      initialValues={initialValues}
      onSubmit={handleSubmit}
    >
      <ApplicantFitCheckRequestModalFields
        informationText={match.information_text}
        match={match}
        reference={applicantData?.reference}
        onCancel={handleClose}
      />
    </FormikForm>
  )
}

export default ApplicantFitCheckRequestModal
